/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('.')} */
module.exports = Error;

